// useSocket.js
import { useEffect, useState } from "react";
import { getSocket } from "./socketManager";

export function useSocket() {
  const [currentSocket, setCurrentSocket] = useState(getSocket());

  useEffect(() => {
    setCurrentSocket(getSocket());
  }, []);

  return currentSocket;
}
